import {
    cst_prefecture,
    cst_ab_select,
    cst_landmark_available,
    cst_landmark_type,
    cst_parking_type,
    cst_parking_parallel_type,
    cst_pay_unit_type_day,
    cst_pay_unit_type_month,
    cst_commission_type,
    cst_payment_type,
    cst_tax_in_flag,
    cst_transshipment_flag,
    cst_oneday_flag,
    cst_request_parking_status,
    cst_user_branch_natural_id,
    cst_fraction_amt_flag,
    cst_discount_rate,
    cst_reminder_sms_flag,
    cst_notification_flag,
    cst_request_type,
    cst_want_priority,
    cst_want_guide_type,
    cst_survey_status,
    cst_estimate_status,
    cst_payment_status,
    cst_capacity_flag,
    cst_deposit_status,
    cst_due_day_rule,
    cst_estimate_rule,
    cst_survey_estimate_rule,
    cst_estimate_type,
    cst_invoice_process_status,
    cst_invoice_create_flag,
    // cst_invoice_type,
    cst_is_active,
    cst_is_staff,
    cst_is_superuser,
    cst_migration_type,
    cst_payment_request_status,
    cst_purchase_order_send_flag,
    cst_request_other_status,
    cst_route_map_parking_flag,
    cst_supplier_type,
    cst_survey_fraction_amt_flag,
    cst_send_destination_type,
    cst_payment_bank_account_type,
    cst_resurvey_flag,
    cst_contract_create_flag,
    cst_payment_due_day_rule,
    cst_survey_capacity_qty_type,
    cst_construction_number_require_flag,
    cst_payment_due_rule_day,
    cst_invoice_customer_user_setting,
    cst_security_deposit_contact_status,
    cst_security_deposit_status,
    cst_security_deposit_collect_type,
    cst_invoice_list_create_flag,
    cst_invoice_list_create_type, // 2021-11-26 feature/1041
    cst_accounts_receivable_status,
    new_cst_receivable_collect_type,
    cst_receivable_collect_type,
    cst_customer_branch_noname_flag,
    cst_customer_system_use_flag,
    cst_customer_system_use_flag_for_list,
    cst_system_type,
    cst_information_display_header,
    cst_information_display_advertisement,
    cst_information_status,
    cst_information_data_type,
    cst_estimate_cancel_status,
    cst_cu_customer_option_approval,
    cst_cu_customer_option_approval_step,
    cst_cu_customer_option_data_scope,
    cst_delete_flag,
    cst_deposit_collect_type,
    cst_customer_branch_reminder_send_flag,
    cst_customer_user_reminder_send_flag,
    cst_information_not_login,
    cst_supplier_bank_account_type,
    cst_supplier_antisocial_forces_flag,
    cst_order_box_status,
    cst_customer_agreement_status,
    cst_request_box_status,
    cst_estimate_management_memo_type,
    cst_contact_memo_for_customer_user,
    cst_auto_approval_flag,
    cst_receivable_collect_bank_type,
    cst_non_taxable_flag,
    cst_invoice_payment_type,
    cst_invoice_business_type,
    cst_cannot_extention_flag,
    cst_auto_order_display_flag,
    cst_auto_order_function_flag,
    cst_auto_order_execution_flag,
    cst_dandori_work_use_flag,
    cst_banned_flag,
    cst_ex_genba_plus_use_flag,
    cst_ex_andpad_use_flag,
    cst_ex_andpad_quote_file_flag,
    cst_road_usage_permission_use_flag
} from '../variables/codes_map';
import Format from '../common/Format';

export default class FormatCode {
    static decode(type,value) {

        var data = [];
        switch(type){
            case "prefecture" :
            case "cst_prefecture" :
                data = cst_prefecture;
            break;
            case "ab_select" :
            case "cst_ab_select" :
                data = cst_ab_select;
            break;
            case "landmark_available" :
            case "cst_landmark_available" :
                data = cst_landmark_available;
            break;
            case "landmark_type" :
            case "cst_landmark_type" :
                data = cst_landmark_type;
            break;
            case "parking_type" :
            case "cst_parking_type" :
                data = cst_parking_type;
            break;
            case "parking_parallel_type" :
            case "cst_parking_parallel_type" :
                data = cst_parking_parallel_type;
            break;
            case "pay_unit_type_day" :
            case "cst_pay_unit_type_day" :
                data = cst_pay_unit_type_day;
            break;
            case "pay_unit_type_month" :
            case "cst_pay_unit_type_month" :
                data = cst_pay_unit_type_month;
            break;
            case "commission_type" :
            case "cst_commission_type" :
                data = cst_commission_type;
            break;
            case "payment_type" :
            case "cst_payment_type" :
                data = cst_payment_type;
            break;

            case "tax_in_flag" :
            case "cst_tax_in_flag" :
                data = cst_tax_in_flag;
            break;
            case "transshipment_flag" :
            case "cst_transshipment_flag" :
                data = cst_transshipment_flag;
            break;
            case "oneday_flag" :
            case "cst_oneday_flag" :
                data = cst_oneday_flag;
            break;
            case "request_parking_status" :
            case "cst_request_parking_status" :
                data = cst_request_parking_status;
            break;
            case "landmark_branch" :
            case "cst_user_branch_natural_id" :
                data = cst_user_branch_natural_id;
            break;
            case "fraction_amt_flag" :
            case "cst_fraction_amt_flag" :
                data = cst_fraction_amt_flag;
            break;
            case "discount_rate" :
            case "cst_discount_rate" :
                data = cst_discount_rate;
            break;
            case "reminder_sms_flag" :
            case "cst_reminder_sms_flag" :
                data = cst_reminder_sms_flag;
            break;
            case "notification_flag":
            case "cst_notification_flag":
                data = cst_notification_flag;
            break;
            case "request_type":
            case "cst_request_type":
                data = cst_request_type;
            break;
            case "want_priority":
            case "cst_want_priority":
                data = cst_want_priority;
            break;
            case "want_guide_type":
            case "cst_want_guide_type":
                data = cst_want_guide_type;
            break;            
            case "survey_status":
            case "cst_survey_status":
                data = cst_survey_status;
            break;            
            case "request_other_status":
            case "cst_request_other_status":
                data = cst_request_other_status;
            break;
            case "cst_estimate_status":
                data = cst_estimate_status;
            break;
            case "cst_payment_status":
                data = cst_payment_status;
            break;
            case "cst_capacity_flag":
                data = cst_capacity_flag;
            break;
            case "cst_deposit_status":
                data = cst_deposit_status;
            break;
            case "cst_due_day_rule":
                data = cst_due_day_rule;
            break;
            case "cst_estimate_rule":
                data = cst_estimate_rule;
            break;
            case "cst_survey_estimate_rule":
                data = cst_survey_estimate_rule;
            break;
            case "cst_estimate_type":
                data = cst_estimate_type;
            break;
            case "cst_invoice_process_status":
                data = cst_invoice_process_status;
            break;
            case "cst_invoice_create_flag":
                data = cst_invoice_create_flag;
            break;
            case "cst_is_active":
                data = cst_is_active;
            break;
            case "cst_is_staff":
                data = cst_is_staff;
            break;
            case "cst_is_superuser":
                data = cst_is_superuser;
            break;
            case "cst_migration_type":
                data = cst_migration_type;
            break;
            case "cst_payment_request_status":
                data = cst_payment_request_status;
            break;
            case "cst_purchase_order_send_flag":
                data = cst_purchase_order_send_flag;
            break;
            case "cst_request_other_status":
                data = cst_request_other_status;
            break;
            case "cst_route_map_parking_flag":
                data = cst_route_map_parking_flag;
            break;
            case "cst_supplier_type":
                data = cst_supplier_type;
            break;
            case "cst_survey_fraction_amt_flag":
                data = cst_survey_fraction_amt_flag;
            break;
            case "cst_non_taxable_flag":
                data = cst_non_taxable_flag;
            break;
            case "comma_delimited":
                return Format.comma_delimited(value)
            case "phone_number":
                return Format.phone_number(value)
            case "zero_one_to_symbol":
                return Format.zero_one_to_symbol(value)
            case "format_date":
                return Format.format_date(value)
            case "format_datetime":
                return Format.format_datetime(value)
            case "cst_send_destination_type":
                data = cst_send_destination_type;
            break;
            case "cst_payment_bank_account_type":
                data = cst_payment_bank_account_type;
            break;
            case "cst_resurvey_flag":
                data = cst_resurvey_flag;
            break;
            case "cst_contract_create_flag":
                data = cst_contract_create_flag;
            break;
            case "cst_payment_due_day_rule":
                data = cst_payment_due_day_rule;
            break;
            case "cst_survey_capacity_qty_type":
                data = cst_survey_capacity_qty_type;
            break;
            case "cst_construction_number_require_flag":
                data = cst_construction_number_require_flag;
            break;
            case "cst_payment_due_rule_day":
                data = cst_payment_due_rule_day;
            break;
            case "cst_invoice_customer_user_setting":
                data = cst_invoice_customer_user_setting;
            break;
            case "cst_security_deposit_contact_status":
                data = cst_security_deposit_contact_status;
            break;
            case "cst_security_deposit_status":
                data = cst_security_deposit_status;
            break;
            case "cst_security_deposit_collect_type":
                data = cst_security_deposit_collect_type;
            break;
            case "cst_invoice_list_create_flag":
                data = cst_invoice_list_create_flag;
            break;
            case "cst_invoice_list_create_type":
                data = cst_invoice_list_create_type;
            break;
            case "cst_accounts_receivable_status":
                data = cst_accounts_receivable_status;
            break;
            case "cst_receivable_collect_type":
                data = cst_receivable_collect_type;
            break;
            case "new_cst_receivable_collect_type":
                console.log(value)
                data = [3,4,6,7,8,9].includes(value) ? cst_receivable_collect_type : new_cst_receivable_collect_type;
            break;
            case "cst_deposit_collect_type":
                data = cst_deposit_collect_type;
            break;
            case "cst_customer_branch_noname_flag":
                data = cst_customer_branch_noname_flag;
            break;
            case "cst_customer_system_use_flag":
                data = cst_customer_system_use_flag;
            break;
            case "cst_customer_system_use_flag_for_list":
                data = cst_customer_system_use_flag_for_list;
            break;
            case "cst_system_type":
                data = cst_system_type;
            break;
            case "cst_information_display_header":
                data = cst_information_display_header;
            break;
            case "cst_information_display_advertisement":
                data = cst_information_display_advertisement;
            break;
            case "cst_information_status":
                data = cst_information_status;
            break;
            case "cst_information_data_type":
                data = cst_information_data_type;
            break;
            case "cst_estimate_cancel_status":
                data = cst_estimate_cancel_status;
            break;
            case "cst_cu_customer_option_approval":
                data = cst_cu_customer_option_approval;
            break;
            case "cst_cu_customer_option_approval_step":
                data = cst_cu_customer_option_approval_step;
            break;
            case "cst_cu_customer_option_data_scope":
                data = cst_cu_customer_option_data_scope;
            break;
            case "cst_delete_flag":
                data = cst_delete_flag;
            break;
            case "cst_banned_flag":
                data = cst_banned_flag;
            break;
            case "cst_customer_branch_reminder_send_flag":
                data = cst_customer_branch_reminder_send_flag;
            break;
            case "cst_customer_user_reminder_send_flag":
                data = cst_customer_user_reminder_send_flag;
            break;           
            case "format_hankaku_lower":
                data = Format.format_hankaku_lower(value);
            break;           
            case "cst_information_not_login":
                data = cst_information_not_login;
            break;
            // 2022/07/12 
            case "cst_supplier_bank_account_type":
                data = cst_supplier_bank_account_type;
            break;
            // 2022/07/15
            case "cst_supplier_antisocial_forces_flag":
                data = cst_supplier_antisocial_forces_flag;
            break;
            // 2022/08/19
            case "cst_order_box_status":
                data = cst_order_box_status;
            break;
            case "cst_customer_agreement_status":
                data = cst_customer_agreement_status;
            break;
            case "request_box_status":
            case "cst_request_box_status":
                data = cst_request_box_status;
            break;
            case "cst_estimate_management_memo_type":
                data = cst_estimate_management_memo_type;
            break;
            case "cst_contact_memo_for_customer_user":
                data = cst_contact_memo_for_customer_user;
            break;
            case "cst_auto_approval_flag":
                data = cst_auto_approval_flag;
            break;
            case "cst_receivable_collect_bank_type":
                data = cst_receivable_collect_bank_type;
            break;
            case "cst_invoice_business_type":
                data = cst_invoice_business_type;
            break;
            case "cst_invoice_payment_type":
                data = cst_invoice_payment_type;
            break;
            case "cst_cannot_extention_flag":
                data = cst_cannot_extention_flag;
            break;
            case "cst_auto_order_display_flag":
                data = cst_auto_order_display_flag;
            break;
            case "cst_auto_order_function_flag":
                data = cst_auto_order_function_flag;
            break;
            case "cst_auto_order_execution_flag":
                data = cst_auto_order_execution_flag;
            break;
            case "cst_dandori_work_use_flag":
                data = cst_dandori_work_use_flag;
            break;
            case "cst_ex_genba_plus_use_flag":
                data = cst_ex_genba_plus_use_flag;
            break;
            case "cst_ex_andpad_use_flag":
                data = cst_ex_andpad_use_flag;
            break;
            case "cst_ex_andpad_quote_file_flag":
                data = cst_ex_andpad_quote_file_flag;
            break;
            case "cst_road_usage_permission_use_flag":
                data = cst_road_usage_permission_use_flag;
            break;
            default:
                // console.log("FormatCode:"+type);
                return value;
        }
        
        for(var i=0;i<data.length;i++){
            
            if(data[i]["value"] == value){
                return data[i]["label"];
            }
        }
        return "";
    }
}